/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CardContent } from '../../models/card-content';

export interface ApiMasterCardContentGetActiveGet$Params {
}

export function apiMasterCardContentGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterCardContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CardContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCardContentGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CardContent>>;
    })
  );
}

apiMasterCardContentGetActiveGet.PATH = '/api/Master/CardContent/GetActive';
